import { useEffect } from 'react';
import Swiper, { Autoplay } from 'swiper';
import Particles from './particles';
import 'swiper/swiper.min.css';
import {
	ArrowsPointingOutIcon,
	ClockIcon,
	TruckIcon,
} from '@heroicons/react/24/outline';
import {
	ArtificialIntelligenceOutline,
	ClinicalFeOutline,
	MedicalSample,
	Referral,
	TestTubes,
	VirusResearch,
	Calendar,
} from 'healthicons-react';
import { useTranslation } from 'react-i18next';

const items = [
	{
		value: 'hero.carrousel1',
		icon: <Calendar className="h-8 w-8" />,
	},
	{
		value: 'hero.carrousel2',
		icon: <Referral className="h-8 w-8" />,
	},
	{
		value: 'hero.carrousel3',
		icon: <ClockIcon className="h-7 w-7" />,
	},
	{
		value: 'hero.carrousel4',
		icon: <MedicalSample className="h-8 w-8" />,
	},
	{
		value: 'hero.carrousel5',
		icon: <TruckIcon className="h-7 w-7" />,
	},
	{
		value: 'hero.carrousel6',
		icon: <TestTubes className="h-8 w-8" />,
	},
	{
		value: 'hero.carrousel7',
		icon: <ArrowsPointingOutIcon className="h-7 w-7" />,
	},
	{
		value: 'hero.carrousel8',
		icon: <VirusResearch className="h-8 w-8" />,
	},
	{
		value: 'hero.carrousel9',
		icon: <ArtificialIntelligenceOutline className="h-8 w-8" />,
	},
	{
		value: 'hero.carrousel10',
		icon: <ClinicalFeOutline className="h-8 w-8" />,
	},
];

Swiper.use([Autoplay]);

export default function Clients() {
	const { t } = useTranslation();
	useEffect(() => {
		const carousel = new Swiper('.clients-carousel', {
			slidesPerView: 'auto',
			spaceBetween: 64,
			centeredSlides: true,
			loop: true,
			speed: 5000,
			noSwiping: true,
			noSwipingClass: 'swiper-slide',
			autoplay: {
				delay: 0,
				disableOnInteraction: true,
			},
		});
	}, []);

	return (
		<section>
			<div className="relative mx-auto max-w-6xl px-4 sm:px-6">
				{/* Particles animation */}
				<div className="absolute inset-0 mx-auto max-w-6xl px-4 sm:px-6">
					<Particles className="absolute inset-0 -z-10" quantity={5} />
				</div>

				<div
					className="py-12 md:py-16"
					data-aos="fade-down"
					data-aos-delay="500"
				>
					<div className="overflow-hidden">
						{/* Carousel built with Swiper.js [https://swiperjs.com/] */}
						{/* * Custom styles in src/css/additional-styles/theme.scss */}
						<div className="clients-carousel swiper-container relative before:pointer-events-none before:absolute before:inset-0 before:z-10 before:w-32 before:bg-gradient-to-r before:from-slate-900 after:pointer-events-none after:absolute after:inset-0 after:left-auto after:z-10 after:w-32 after:bg-gradient-to-l after:from-slate-900">
							<div className="swiper-wrapper select-none items-center !ease-linear">
								{/* Carousel items */}

								{items.map(item => (
									<div className="swiper-slide !w-auto" key={item.value}>
										<div className="flex items-center gap-2 text-gray-400">
											{item.icon}
											<h4 className="text-lg font-bold capitalize">
												{t(item.value)}
											</h4>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
